import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import MaterialSpinner from "../../ui/materialSpinner";
import WithCanvasImage from "../hocs/withCanvasImage";
import LookPolicyLinks from "../lookPolicyLinks";
import {getCommonVisualizerType, IS_LIXIL_SERVERS} from "../../../config";
import {capitalizeFirstLetters} from "../../../misc/helpers";

const LookListLeft = (props) => {

  const {onBackClick, isMobile, fabricatorData, isPhoneNumberValidated} = props;
  const fabricatorSettings = fabricatorData.settings;

  if (isMobile) {
    return null
  }

  const getQuote = fabricatorSettings.enableQuote && !isPhoneNumberValidated;

  const visualizerType = capitalizeFirstLetters(getCommonVisualizerType());

  return (
    <section className="ll-body__left">
      <div className="ll-top">
        <WithCanvasImage>
          {(canvasSrc) => (
            <div className={"ll-preview" + (!canvasSrc ? " ll-preview--loading" : "")}>
              {canvasSrc
                ? <img src={canvasSrc} alt="" className="ll-preview__image"/>
                : <MaterialSpinner/>}
            </div>
          )}
        </WithCanvasImage>
        <div className="ll-back">
          <Button className={"look-button look-button--secondary"}
                  startIcon={<ChevronLeftIcon />}
                  onClick={onBackClick}>
            <FormattedMessage id="look.list.backButton"/>
          </Button>
        </div>
        {IS_LIXIL_SERVERS || fabricatorData.isEncore ? null : (
          <h4 className="ll-top__title">
            <FormattedMessage id={getQuote ? "look.list.left.title1.getQuote" : "look.list.left.title1"} values={{
              visualizerType
            }}/>
            <br/>
            {getQuote ? <br/> : null}
            <FormattedMessage id={getQuote ? "look.list.left.title2.getQuote" : "look.list.left.title2"}/>
          </h4>
        )}
        {getQuote || IS_LIXIL_SERVERS || fabricatorData.isEncore ? null : (
          <Fragment>
            <p className="ll-top__text">
              <FormattedMessage id="look.list.left.text1" values={{
                visualizerType
              }}/>
              {fabricatorSettings.showPricing ? <FormattedMessage id="look.list.left.text1-2"/> : null}
            </p>
            <p className="ll-top__text">
              {fabricatorSettings.showPricing ? <FormattedMessage id="look.list.left.text2"/> : null}
              <FormattedMessage id="look.list.left.text2-2"/>
            </p>
            {fabricatorSettings.checkout ? (
              <p className="ll-top__text">
                <FormattedMessage id="look.list.left.text3"/>
              </p>
            ) : null}
          </Fragment>
        )}
        {fabricatorData.isEncore ? (
          <p className="ll-top__title">
            <FormattedMessage id="look.list.left.text1" values={{
              visualizerType
            }}/>
          </p>
        ) : null}
      </div>
      <div className="ll-bottom">
        <LookPolicyLinks position={"left"} isSimple={true}/>
      </div>
    </section>
  )
};

LookListLeft.propTypes = {
  onBackClick: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const fabricatorData = store.fabricatorState;
  const {isPhoneNumberValidated} = store.userState;

  return {
    isMobile,
    fabricatorData,
    isPhoneNumberValidated,
  };
};

export default injectIntl(connect(mapStateToProps)(LookListLeft))
